import firebase from "firebase/app";
import router from "@/router";

declare const window: any;

const state = {
    user: null, 
    error: null 
};

const actions = {
    authAction({ commit, dispatch }) {
        
        firebase.auth().onAuthStateChanged(user => {
            
            if(user) {
                
                if(!window.gapi.auth2.getAuthInstance()) {

                   // dispatch('logoutAction');
                
                } else {
              
                    if(window.gapi.auth2.getAuthInstance().isSignedIn.get()) {
                       
                        console.log('signed in');
                        commit("setUser", user);
                        router.replace('/a202');

                    } else {
                       // dispatch('logoutAction');
                    }
                }

            } else {
               // dispatch('logoutAction');
            }
        });

    },
    async loginAction({ commit, dispatch }) {
        
        console.log('here');
        await dispatch('logoutAction');

        const googleAuth = window.gapi.auth2.getAuthInstance();
        const googleUser = await googleAuth.signIn();
        const token = googleUser.getAuthResponse().id_token;
        
        const credential = firebase.auth.GoogleAuthProvider.credential(token);
        await firebase.auth().signInWithCredential(credential)
            .then(result => {
                const credential = result.credential as firebase.auth.OAuthCredential;
                commit("setToken", credential.accessToken);
            })
            .catch(error => {
                console.log(error.message);
                commit("setError", error.message);
            });
    },
    logoutAction({ commit }) {

        commit("setUser", null);
        commit("setToken", null);
        window.gapi.auth2.getAuthInstance().signOut();
        firebase.auth().signOut();

        if(router.currentRoute.path != '/') {
            router.replace('/');
        }
    
    }
};

const getters = {
    getUser(state) {
      return state.user;
    },
    isUserAuth(state) {
      return !!state.user;
    },
    getError(state) {
      return state.error;
    },
    getToken(state) {
      return state.token;
    }
  };

const mutations = {

    setUser(state, payload) {
      state.user = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setToken(state, payload) {
      state.token = payload;
    }
};

export default {
    state,
    actions,
    getters,
    mutations
}